import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get costCenter
export const getCostCenter = createAsyncThunk("costCenter/getCostCenter", async (params, { rejectWithValue }) => {
  try {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    const { data } = await API.getCostCenter({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all costCenter
export const getAllCostCenter = createAsyncThunk("costCenter/getAllCostCenter", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllCostCenter();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("costCenter/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("costCenter/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "costCenter/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPageCostCenter({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create costCenter
export const createCostCenter = createAsyncThunk("costCenter/createCostCenter", async (data, { rejectWithValue }) => {
  const { name, code, costCenterType, dimension, startTime, endTime, isActive } = data;

  try {
    const body = JSON.stringify({ name, code, costCenterType, dimension, startTime, endTime, isActive });
    const { data } = await API.createCostCenter(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});
export const updateCostCenter = createAsyncThunk("costCenter/updateCostCenter", async (data, { rejectWithValue }) => {
  const { id, values } = data;
  const { name, code, costCenterType, dimension, startTime, endTime, isActive } = values;
  try {
    const body = JSON.stringify({ name, code, costCenterType, dimension, startTime, endTime, isActive });
    const { data } = await API.updateCostCenter(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

// handle search
export const handleSearch = createAsyncThunk("costCenter/handleSearch", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getCostCenter({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
